module.exports = __webpack_public_path__ + "static/media/12b00842-ec20-4c7f-aa72-802fb00f6cc4.0307d586.woff";